const { CHANNEL_INTERFACE_TYPE } = require('@/enums');
const { getSupportChannelOptions } = require('@/tools');

module.exports = (s) => {
  return {
    // 广告平台
    advertiser: {
      type: 'select',
      props: {
        placeholder: '请选择广告平台',
      },
      options: getSupportChannelOptions(),
      value: CHANNEL_INTERFACE_TYPE.GDT,
      on: {
        'change': s.getMediasList,
      },
    },

    // 广告主id
    advertiser_id: {
      type: 'select',
      props: {
        placeholder: '请选择广告主',
      },
      options: [],
      value: '',
    },
    // 计划状态
    status: {
      type: 'select',
      props: {
        placeholder: '请选择计划状态',
      },
      options: [
        { label: '提交', value: 1 },
        { label: '成功', value: 2 },
        { label: '失败', value: 3 },
      ],
      value: '',
    },
    // 计划名称
    name: {
      type: 'input',
      props: {
        placeholder: '请输入计划名称',
      },
      width: '300px',
      value: '',
    },
  };
};

